import React, { useState } from 'react';
import {postLogin} from "./api";
import "./Login.css"

function Login() {
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");
    const onLogin = () => {
        postLogin({username, password})
            .then(response => {
                switch (response.status) {
                    case 200: break;
                    case 400: setError("Wrong arguments"); break;
                    case 401: setError("Wrong password"); break;
                    case 404: setError("Company is not found"); break;
                    case 500:
                    default:
                        setError("Internal server error. Try again later...")
                }
                return response.json()
            })
            .then(json => {
                if (json.token) {
                    localStorage.setItem("token", json.token)
                    window.location.href = "/"
                } else if (json.error) {
                    setError(json.error)
                }
            })
            .catch((err) => {
                console.error(err)
                setError("Internal server error. Try again later...")
            })
    }
    return (
        <div>
            <center><h1 className="title"> Business Dashboard </h1></center>
            <div className="wrapper">
                <div className="logo">
                    <img src="https://my.trustelev8.com/assets/te/images/welcome.png" alt=""/>
                </div>
                <div className="text-center mt-4 name">
                    Log in
                </div>
                <div>{error}</div>
                <div id="login-form" className="p-3 mt-3" >
                    <div className="form-field d-flex align-items-center">
                        <span className="far fa-user"></span>
                        <input type="text" name="username" id="username" placeholder="Your company's ID" onChange={(e) => setUsername(e.target.value)}/>
                    </div>
                    <div className="form-field d-flex align-items-center">
                        <span className="fas fa-key"></span>
                        <input type="password" name="password" id="pwd" placeholder="Password" onChange={(e) => setPassword(e.target.value)}/>
                    </div>
                    <button type="submit" className="btn mt-3" onClick={onLogin}>Login</button>
                </div>
            </div>
        </div>
    );
}

export default Login;
